// src/components/user/sidebar/UserSidebar.jsx
import React, { useContext, useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import {
  FiGrid,
  FiClipboard,
  FiDollarSign,
  FiHeadphones,
  FiBell,
  FiSettings,
  FiUser,
  FiStar,
  FiHeart,
  FiSave,
  FiLogOut,
  FiChevronDown,
  FiChevronUp,
} from "react-icons/fi";
import { FaTractor, FaSignOutAlt, FaTimes } from "react-icons/fa";
import "../../../assets/css/useradmin/usersidebar/UserSideBar.css";
import AppContext from "../../../context/AppContext";

const UserSidebar = ({ isOpen, onClose }) => {
  const { setLoggedInCustomer, setAuthToken, setIsLoggedIn, baseUrl, authToken, loggedInCustomer } =
    useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  // 👇 Sidebar par "Notifications" tab ke aage kitni unread notifications hain,
  // yeh yahan fetch hoti hai — har 20 second me refresh bhi hoti hai taake
  // naye aane par khud-ba-khud number update ho jaye.
  useEffect(() => {
    if (!loggedInCustomer?.id) return;

    const fetchUnreadCount = () => {
      axios
        .post(
          `${baseUrl}/customer/notifications/getUnreadCount`,
          { srcustomer_id: loggedInCustomer.id },
          { headers: { Authorization: `Bearer ${authToken}` } }
        )
        .then((res) => {
          if (res.data.success) setUnreadCount(res.data.count);
        })
        .catch(() => {});
    };

    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, 20000);
    return () => clearInterval(interval);
  }, [loggedInCustomer, baseUrl, authToken]);

  const menu = [
    {
      id: "dashboard",
      label: "Dashboard",
      icon: <FiGrid />,
      path: "/user/dashboard",
    },
    // {
    //   id: 'rentals',
    //   label: 'Rental Request',
    //   icon: <FiClipboard />,
    //   path: '/user/my-rentals'
    // },
    // {
    //   id: 'maintenance',
    //   label: 'Maintenance Request',
    //   icon: < FiSave />,
    //   path: '/user/maintenance'
    // },
    {
      id: "bookings",
      label: "Booking History",
      icon: <FiClipboard />,
      path: "/user/booking-history",
    },
    {
      id: "messages",
      label: "Messages",
      icon: <FiClipboard />,
      path: "/user/messages",
    },
    {
      id: "payments",
      label: "Payments",
      icon: <FiDollarSign />,
      path: "/user/payments",
    },
    // {
    //   id: 'favorites',
    //   label: 'Favorites',
    //   icon: < FiHeart />,
    //   path: '/user-admin/favorites'
    // },
    // {
    //   id: 'reviews',
    //   label: 'Reviews & Ratings',
    //   icon: <FiStar />,
    //   path: '/user/reviews'
    // },
    {
      id: "dispute",
      label: "Dispute",
      icon: <FiBell />,
      path: "/user/dispute",
    },
    // {
    //   id: 'profile',
    //   label: 'Profile',
    //   icon: <FiUser />,
    //   path: '/user-admin/profile'
    // },
    {
      id: "notifications",
      label: "Notifications",
      icon: <FiBell />,
      path: "/user/Usernotification",
    },
    {
      id: "profile",
      label: "Profile",
      icon: <FiUser />,
      path: "/user/profile",
    },
  ];

  const handleNavigation = (path) => {
    navigate(path);
    if (window.innerWidth <= 768 && onClose) {
      onClose();
    }
  };

  const handleUserMenuToggle = () => {
    setIsUserMenuOpen(!isUserMenuOpen);
  };
  const [show, setShow] = useState(false);

  // const Logout = () => {
  //   console.log("Logout function called");

  //   localStorage.removeItem("customerEmail");
  //   localStorage.removeItem("customerPassword");
  //   navigate('/auth');
  // }

  const Logout = () => {
    setLoggedInCustomer(null);
    setAuthToken(null);
    setIsLoggedIn(false);
    localStorage.removeItem("authToken");
    localStorage.removeItem("LoggedInCustomer");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("userPassword");
    setShow(false);
    navigate("/auth");
  };

  const UserLogout = () => {
    const [show, setShow] = useState(false);
    const navigate = useNavigate();

    const handleLogout = () => {
      localStorage.clear(); // clear user data
      navigate("/registration"); // redirect to login
    };
  };

  const isActive = (path) => {
    return (
      location.pathname === path || location.pathname.startsWith(path + "/")
    );
  };

  return (
    <>
      {/* Overlay for mobile */}
      {isOpen && <div className="user-sidebar-overlay" onClick={onClose}></div>}

      <aside className={`user-smart-agri-sidebar ${isOpen ? "open" : ""}`}>
        {/* Logo & Brand Section */}
        <div className="user-sidebar-brand">
          <div className="user-sidebar-logo">
            <FaTractor size={32} />
          </div>
          <div className="user-sidebar-brand-text">
            <h3 className="user-sidebar-brand-title">Smart Agri</h3>
            <span className="user-sidebar-brand-subtitle">RENT</span>
          </div>
        </div>

        {/* Admin Profile */}
        {/* <div className="user-sidebar-profile">
                <div className="user-sidebar-avatar">R</div>
                <div className="user-sidebar-profile-text">
                  <h4 className="user-sidebar-profile-name">User Admin Panel</h4>
                  <span className="user-sidebar-profile-email">user@smartagrirent.com</span>
                </div>
              </div> */}

        {/* Navigation Menu */}
        <nav className="user-sidebar-menu">
          {menu.map((item) => (
            <div key={item.path}>
              <button
                className={`user-sidebar-menu-item ${isActive(item.path) ? "active" : ""}`}
                onClick={() => {
                  if (item.hasSubmenu) {
                    handleUserMenuToggle();
                  } else {
                    handleNavigation(item.path);
                  }
                }}
              >
                <span className="user-menu-icon">{item.icon}</span>
                <span className="user-menu-label">{item.label}</span>
                {item.id === "notifications" && unreadCount > 0 && (
                  <span
                    style={{
                      marginLeft: "auto",
                      background: "#FDB714",
                      color: "#fff",
                      fontSize: "11px",
                      fontWeight: 700,
                      borderRadius: "999px",
                      minWidth: "20px",
                      height: "20px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "0 6px",
                    }}
                  >
                    {unreadCount > 99 ? "99+" : unreadCount}
                  </span>
                )}
                {item.hasSubmenu && (
                  <span className="user-menu-chevron">
                    {isUserMenuOpen ? <FiChevronUp /> : <FiChevronDown />}
                  </span>
                )}
              </button>

              {/* Submenu */}
              {item.submenu && isUserMenuOpen && (
                <div className="user-sidebar-submenu">
                  {item.submenu.map((sub) => (
                    <button
                      key={sub.path}
                      className={`user-sidebar-submenu-item ${location.pathname === sub.path ? "active" : ""}`}
                      onClick={() => handleNavigation(sub.path)}
                    >
                      <span className="user-submenu-dot">•</span>
                      <span>{sub.label}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>

        {/* Logout Button */}
        <button className="user-logout-btn" onClick={() => setShow(true)}>
          <FaSignOutAlt />
          Logout
        </button>

        {/* Confirm Logout Modal */}
        <Modal show={show} onHide={() => setShow(false)} centered>
          <div className="logout-modal">
            <div className="logout-header">
              <h4>Confirm Logout</h4>
              <FaTimes className="close-icon" onClick={() => setShow(false)} />
            </div>

            <div className="logout-body">
              <div className="logout-icon-wrapper">
                <FaSignOutAlt className="modal-logout-icon" />
              </div>
              <p>Are you sure you want to logout from User Panel?</p>
            </div>

            <div className="logout-footer">
              <button className="cancel-btn" onClick={() => setShow(false)}>
                Cancel
              </button>
              <button className="confirm-btn" onClick={Logout}>
                Yes, Logout
              </button>
            </div>
          </div>
        </Modal>
      </aside>
    </>
  );
};

export default UserSidebar;
